import scoirSchoolIcon from './map-icons/scoir-school.svg'
import scoirSchoolVisitIcon from './map-icons/scoir-school-visit.svg'
import nonScoirSchoolIcon from './map-icons/non-scoir-school.svg'

import scoirSchoolSelectedIcon from './map-icons/scoir-school-selected.svg'
import scoirSchoolVisitSelectedIcon from './map-icons/scoir-school-visit-selected.svg'
import nonScoirSchoolSelectedIcon from './map-icons/non-scoir-school-selected.svg'

const defaultNormalSize = {
  width: 20,
  height: 32,
}
const defaultSelectedSize = {
  width: 30,
  height: 48,
}

const icons = {
  scoir: {
    url: scoirSchoolIcon,
    scaledSize: defaultNormalSize,
  },
  scoirSelected: {
    url: scoirSchoolSelectedIcon,
    scaledSize: defaultSelectedSize,
    anchor: {
      x: defaultSelectedSize.width / 2,
      y: defaultSelectedSize.height - 2.5,
    },
  },
  scoirVisit: {
    url: scoirSchoolVisitIcon,
    scaledSize: {
      width: 34,
      height: 34,
    },
  },
  scoirVisitSelected: {
    url: scoirSchoolVisitSelectedIcon,
    scaledSize: {
      width: 44,
      height: 48,
    },
    anchor: {
      x: 44 / 2,
      y: 48 - 2.5,
    },
  },
  nonscoir: {
    url: nonScoirSchoolIcon,
    scaledSize: defaultNormalSize,
  },
  nonscoirSelected: {
    url: nonScoirSchoolSelectedIcon,
    scaledSize: defaultSelectedSize,
    anchor: {
      x: defaultSelectedSize.width / 2,
      y: defaultSelectedSize.height - 2.5,
    },
  },
}

export const getIconForHighSchool = (isActive, hasVisit, isSelected) => {
  const parts = [isActive ? 'scoir' : 'nonscoir', hasVisit ? 'Visit' : '', isSelected ? 'Selected' : '']

  return icons[parts.join('')]
}
